module Meevo.Plugins.Register {
    export class MeevoSelfPayment implements ng.IComponentController  {
        static $inject = ["meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.busy.BusyService",
            "$q"
        ];
        $onInit() {
            if (this.canEditClient) {
                let clientRequests = [];
                _(this.registerContext.allUniqueClients).chain()
                    .where({ clientType: Model.ClientTypeEnum.Client }).pluck("client").value().forEach(saleClient => {
                        clientRequests.push(this.getFullClient(saleClient.id));
                    });

                this.$q.all(clientRequests).then(response => {
                    this.saleClients = response;
                    if (this.saleClients.length > 0) {
                        this.saleClients.forEach(saleClient => {
                            saleClient.hidden = false;
                            saleClient.displayName = this.registerContext.formatClientDisplayName(saleClient.firstName, saleClient.lastName)
                        })
                        this.saleClient = this.saleClients[0];
                        this.selfPayment.payerName = this.saleClient.displayName;
                        this.saleClientChanged();
                    }
                    else {
                        this.useOtherClient = true;
                    }
                });
            }
        }
        sale;
        canEditClient;
        showCards;
        newClient;
        fullClient;
        mobileNumbers;
        fullMobileNumber;
        creditCards;
        saleClient;
        registerContext;
        saleClients;
        zipCode;
        isHsaFsa;
        showHsaFsa;
        formRef;
        useOtherClient: boolean = false;
        isFreeformMobileNumber: boolean = false;
        isFreeformEmailAddress: boolean = false;
        regexEmailValidator: RegExp = Meevo.Components.Common.Constants.REGEX_EMAIL_VALIDATOR;
        private _selfPayment
        get selfPayment() {
            return this._selfPayment;
        }
        set selfPayment(selfPayment) {
            this._selfPayment = selfPayment;

            if (!selfPayment) {
                return;
            }

            this.selfPayment.refreshClient = () => {
                this.getFullClient(this.selfPayment.clientId).then(client => {
                    this.loadClient(client);
                });
            }
            if (selfPayment.clientId) {
                this.getFullClient(this.selfPayment.clientId).then(client => {
                    this.loadClient(client);
                });
            }

            selfPayment.tipTotal = this.registerContext.sale.tip;
            selfPayment.totalPrepaidTipRedeemed = this.registerContext.sale.totalPrepaidTipRedeemed;
            selfPayment.total = this.registerContext.sale.total;
            selfPayment.subTotal = this.registerContext.sale.subTotal;
            selfPayment.taxTotal = this.registerContext.sale.finalTax;
            selfPayment.totalPayments = this.registerContext.sale.paymentLines
                .map(paymentLine => paymentLine.amount)
                .reduce((total, next) => total += next, 0);
            selfPayment.serviceTotal = this.registerContext.sale.saleLines
                .filter(saleLine => saleLine.saleType === Model.SalesTypeEnum.Service)
                .map(serviceSaleLine => serviceSaleLine.basePrice)
                .reduce((total, next) => total += next, 0);
        }
        saleClientChanged() {
            this.newClient = undefined;
            this.selfPayment.clientId = this.saleClient.id;
            this.loadClient(this.saleClient, true);
        }
        newClientChanged() {
            if (!this.newClient) {
                return;
            }

            this.selfPayment.clientId = this.newClient.id;
            this.newClient = undefined;

            this.getFullClient(this.selfPayment.clientId).then((client: any) => {
                client.displayName = this.registerContext.formatClientDisplayName(client.firstName, client.lastName);
                this.saleClients = _(this.saleClients).where({ hidden: false });
                this.saleClient = _(this.saleClients).findWhere({ id: client.id });
                if (!this.saleClient) {
                    this.saleClients.push(client);
                    this.saleClient = client;
                    this.saleClient.hidden = true;
                }
                this.loadClient(client, true);
                this.useOtherClient = false;
            });
        }

        doUseOtherClient() {
            this.fullClient = undefined;
            this.useOtherClient = true;
        }

        destinationChanged() {
            this.formRef.selfPayDestination.$setValidity("required", this.selfPayment.sendSms || this.selfPayment.sendEmail);
        }

        getFullClient(id) {
            return this.dataService.getItem("client", id).then((client: any) => {
                if (client.isMinor) {
                    return this.dataService.getItem("client", client.guardianId)
                }
                return this.$q.resolve(client);
            });
        }
        toggleFreeformMobileNumber(clear: boolean) {
            if (clear) {
                this.fullMobileNumber = '';
            }
            this.isFreeformMobileNumber = !this.isFreeformMobileNumber;
            this.selfPayment.isPhoneNumberMasked = !this.isFreeformMobileNumber && this.fullClient.maskingInformation.isPhoneNumberMasked
        }
        toggleFreeformEmailAddress() {
            this.isFreeformEmailAddress = !this.isFreeformEmailAddress;
            this.selfPayment.emailAddress = !this.isFreeformEmailAddress ? this.fullClient.emailAddress : "";
            this.selfPayment.isEmailAddressMasked = !this.isFreeformEmailAddress && this.fullClient.maskingInformation.isEmailAddressMasked
        }

        loadClient(client, clientChanged: boolean = false) {
            this.fullClient = client;
            this.selfPayment.payerName = client.displayName;
            if (clientChanged) {
                this.selfPayment.phoneNumber = undefined;
                this.selfPayment.countryCode = undefined;
                this.selfPayment.emailAddress = undefined;
            }
            //if email for client is masked, have to always default to that since don't know if what's saved with self pay is custom
            if (client.maskingInformation.isEmailAddressMasked || !this.selfPayment.emailAddress) {
                this.selfPayment.emailAddress = client.emailAddress;
            }
            this.selfPayment.isEmailAddressMasked = this.selfPayment.emailAddress === client.emailAddress && client.maskingInformation.isEmailAddressMasked;
            this.selfPayment.isPhoneNumberMasked = client.maskingInformation.isPhoneNumberMasked;
            this.mobileNumbers = _(client.phoneNumbers).filter(phoneNumber => {
                return phoneNumber.type === Model.PhoneTypeEnum.Mobile &&
                    phoneNumber.number
            });
            this.isFreeformMobileNumber = this.mobileNumbers.length === 0;
            if (this.mobileNumbers.length > 0) {
                if (this.selfPayment.phoneNumber) {
                    this.fullMobileNumber = _(this.mobileNumbers).findWhere({ number: this.selfPayment.phoneNumber, countryCode: this.selfPayment.countryCode });
                }
                else {
                    this.fullMobileNumber = _(this.mobileNumbers).findWhere({ smsOptInStateEnum: Meevo.Model.CommunicationOptedInStateEnum.OptedIn }) ||
                        this.mobileNumbers[0]
                    this.selectedMobileNumberChanged();
                }
            }

            this.getCreditCards();
        }
        getCreditCards() {
            if (!this.showCards) {
                return;
            }
            this.dataService.customMethodData(`/api/client/${this.fullClient.id}/creditCard/list`, "post", {
                criteria: {
                    isExpired: false,
                    isApproved: true
                },
                pageNumber: 1,
                itemsPerPage: 100
            }).then(response => {
                this.creditCards = [];
                const creditCards = response.data;
                for (const clientCard of creditCards) {
                    const creditCardExists = this.doesCreditCardExist(clientCard);
                    if (!creditCardExists) {
                        this.creditCards.push(clientCard);
                    }
                }
            });
        }
        isHsaFsaVisible(card) {
            return this.showHsaFsa && card && card.isHsaFsa &&
                   card.merchantProviderId == this.registerContext.selectedMerchantAccount.merchantProviderId;
        }
        private doesCreditCardExist(clientCard) {
            return _(this.creditCards).any((card) =>
                card.cardType == clientCard.cardType &&
                card.creditCardLastFour == clientCard.creditCardLastFour &&
                moment(card.creditCardExpirationDate).format() == moment(clientCard.creditCardExpirationDate).format() &&
                this.isHsaFsaVisible(card) == this.isHsaFsaVisible(clientCard)
            );
        }
        selectedMobileNumberChanged() {
            this.selfPayment.phoneNumber = this.fullMobileNumber.number;
            this.selfPayment.countryCode = this.fullMobileNumber.countryCode;
            this.selfPayment.phoneNumberIndex = this.mobileNumbers.findIndex(number => number === this.fullMobileNumber);
        }
        addCreditCard() {
            const request = {
                templateUrl: "app/components/controls/paymentAccounts/addCreditPaymentAccount.template.html",
                controller: "meevo.components.controls.AddCreditPaymentAccountController",
                controllerAs: "vm",
                bindToController: true,
                locals: {
                    zipCode: this.zipCode,
                    useHostedPage: this.useHostedPage(),
                    merchantAccountId: this.registerContext.getMerchantAccountId(),
                    merchantProviderId: this.registerContext.getMerchantProviderId(),
                    merchantTerminalId: this.registerContext.getMerchantTerminalId(),
                    paymentAccountId: undefined,
                    clientId: this.selfPayment.clientId,
                    isHsaFsa: this.isHsaFsa,
                    showHsaFsa: this.showHsaFsa,
                    showHsaFsaAfterAccountCreation: false,
                    hostedPageIntent: Meevo.Model.HostedPageIntent.ECommerce,
                    paymentAccountType: Model.PaymentAccountTypeEnum.Card,
                    forceManualEntry: false,
                    isHostedPageAutomaticallySwitch: this.registerContext.getIsHostedPageAutomaticallySwitch(),
                    disableBillingAddressEdit: this.registerContext.isMeevoPayProvider(),
                    cardholderName: undefined,
                }
            };

            this.modalService.showCustom(request)
                .then(response => {
                    this.zipCode = response.zipCode;
                    this.isHsaFsa = response.isHsaFsa;
                    if (response.hostedPageTerminal) {
                        this.registerContext.setSelectedTerminal(response.hostedPageTerminal);
                    }
                    this.getCreditCards();
                })
                .catch(response => {
                    if (response && response.hostedPageTerminal) {
                        this.registerContext.setSelectedTerminal(response.hostedPageTerminal);
                    }
                });
        }
        useHostedPage() {
            if (!this.registerContext.selectedMerchantAccount || !this.registerContext.selectedTerminal) {
                return false;
            }
            return this.registerContext.selectedMerchantAccount.hasHostedPageSupport
                && this.registerContext.selectedTerminal.merchantTerminalType === Meevo.Model.MerchantTerminalTypeEnum.Hosted;
        }
        constructor(private dataService: Meevo.Components.BaseClasses.IDataService,
            private modalService: Meevo.Components.Modal.IModalService,
            private busyService: Meevo.Components.Busy.IBusyService,
            private $q: ng.IQService) {
        }
    }
    angular.module("meevo.plugins.register")
        .component("meevoSelfPayment", {
            templateUrl: "app/plugins/register/directives/selfPayment.template.html",
            controller: MeevoSelfPayment,
            controllerAs:"vm",
            bindings: {
                registerContext: "<",
                formRef: "<",
                selfPayment: "<",
                sale: "<",
                canEditClient: "=",
                showCards: "=",
                showHsaFsa: "="
            }
        });
}